<script setup>
import { onMounted, onUnmounted, ref } from "vue";
const navbar = ref(),
  shadowNavbar = ref(),
  appName = import.meta.env.VITE_APP_NAME;

function setNavbarHeight() {
  shadowNavbar.value.style.width = navbar.value.clientWidth + "px";
  shadowNavbar.value.style.height = navbar.value.clientHeight + 1 + "px";
}
function onScreenResize() {
  window.addEventListener("resize", () => {
    setNavbarHeight();
  });
}

onMounted(() => {
  setNavbarHeight();
  onScreenResize();
});
onUnmounted(() => {
  window.removeEventListener("resize", onScreenResize);
});

import { useRouter } from "vue-router";
const router = useRouter();

import { useUIStore } from "@/stores/ui";
const redirect = (destination) => {
  router.push({ name: destination });
};

import useAuthStore from "@/stores/auth";
import { storeToRefs } from "pinia";
const { user } = storeToRefs(useAuthStore());

import useModal from "@/helper/hooks/useModal";
const [isModalOpened, selectedModal, openModal, closeModal] = useModal();
import ConfirmationModal from "../widget/modals/ConfirmationModal.vue";
</script>

<template>
  <header
    class="navbar bg-base-100 absolute inset-x-0 top-0 z-20 shadow"
    ref="navbar"
  >
    <div class="flex-none">
      <button
        @click="useUIStore().toggleSidebar"
        class="btn btn-square btn-ghost"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          class="inline-block w-5 h-5 stroke-current"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          ></path>
        </svg>
      </button>
    </div>
    <div class="flex-1">
      <router-link :to="{ name: 'home' }" class="flex items-center space-x-4">
        <img src="/img/polri-logo.png" alt="" class="h-14 lg:ml-4" />
        <p
          class="inline-block md:text-lg leading-tight md:w-64 font-bold text-stone-900 capitalize"
        >
          {{ appName }}
        </p>
      </router-link>
    </div>
    <div class="flex-none">
      <button
        class="btn btn-circle btn-ghost"
        @click="redirect('notification')"
      >
        <font-awesome-icon :icon="['fas', 'bell']" />
      </button>
      <div class="dropdown dropdown-end">
        <label tabindex="0" class="btn btn-ghost">
          <p class="hidden md:block">{{ user.name }}</p>
          <img
            src="/img/dummyProfile.jpg"
            alt=""
            class="h-8 aspect-square rounded-full"
          />
        </label>
        <ul
          tabindex="0"
          class="menu dropdown-content p-2 shadow bg-base-100 rounded-box w-52 mt-4"
        >
          <li><a @click="redirect('settings')">Pengaturan</a></li>
          <li><a @click="openModal(ConfirmationModal)">Keluar</a></li>
        </ul>
      </div>
    </div>
  </header>
  <div ref="shadowNavbar" />

  <teleport to="body">
    <component
      :is="selectedModal"
      v-if="isModalOpened"
      @close="closeModal"
      @accept="useAuthStore().logout"
      text="Keluar"
      :isPermanent="false"
    ></component>
  </teleport>
</template>
